import type { MusicOnHoldLocale } from './en'

export const musicOnHoldEs = {
  list: {
    title: `Música en espera`,
    loading: `Cargando listas de reproducción...`,
    error: `Error`,
    empty: `No se encontraron listas de reproducción`,
    emptyDescription: `Actualmente no hay listas de reproducción configuradas para esta centralita.`,
    noResults: `Sin resultados`,
    noResultsDescription: `No hay listas de reproducción que coincidan con su búsqueda.`,
    columnName: `Nombre`,
    columnType: `Tipo`,
    columnTracks: `Pistas`,
    columnUpdated: `Actualizado`,
    columnDefault: `Predeterminada`,
    columnPlayer: `Vista previa`,
    noPreview: `Sin audio`,
    previewInDetail: `Abrir para escuchar pistas`,
    defaultDisabledTooltip: `La lista debe tener al menos una pista de audio o una URL de transmisión para poder establecerla como predeterminada.`,
    defaultCurrentTooltip: `Esta es la lista de reproducción predeterminada actual.`,
    defaultSetTooltip: `Establecer como lista predeterminada`,
    defaultBadge: `Predeterminada`,
    systemBadge: `Sistema`,
    notPlayableBadge: `No reproducible`,
    typeList: `Lista`,
    tracksLabel: `pistas`,
    streaming: `En transmisión`,
    myPlaylists: `Mis listas de reproducción`,
    systemPlaylists: `Listas del sistema`,
    searchPlaceholder: `Buscar listas de reproducción...`,
    manageTracksButton: `Pistas de audio`,
    createButton: `+ Crear lista`,
    createDisabledTooltip: `Crear lista aún no está disponible.`,
    columnActions: `Acciones`,
    deleteAriaLabelNamed: `Eliminar lista "{{name}}"`,
    deleteConfirmTitle: `¿Eliminar lista?`,
    deleteConfirmBody: `¿Eliminar "{{name}}"? Esta acción no se puede deshacer.`,
    deleteConfirm: `Eliminar`,
    deleteCancel: `Cancelar`,
    deleteDefaultWarning: `Esta es la lista de música en espera predeterminada. Si la eliminas, se usará la predeterminada del sistema.`,
  },
  detail: {
    loading: `Cargando lista de reproducción...`,
    error: `Error`,
    notFound: `Lista de reproducción no encontrada.`,
    backToList: `← Volver a la lista`,
    editButton: `Editar lista`,
    editDisabledTooltip: `La edición aún no está disponible`,
    defaultBadge: `Predeterminada`,
    systemBadge: `Sistema`,
    generalTitle: `Información general`,
    nameLabel: `Nombre`,
    typeLabel: `Tipo`,
    typeList: `Lista`,
    defaultLabel: `Predeterminada`,
    defaultYes: `Sí`,
    defaultNo: `No`,
    activeLabel: `Activa`,
    activeYes: `Sí`,
    activeNo: `No`,
    idLabel: `ID`,
    uuidLabel: `UUID`,
    createdLabel: `Creada`,
    updatedLabel: `Actualizada`,
    audioTracksTitle: `Pistas de audio`,
    noAudioTracks: `No hay pistas de audio asociadas con esta lista de reproducción.`,
    manageTracksButton: `Administrar pistas`,
  },
  audioTracks: {
    title: `Pistas de audio`,
    loading: `Cargando pistas de audio...`,
    empty: `No se han subido pistas de audio para esta centralita.`,
    columnName: `Nombre`,
    columnFile: `Archivo`,
    uploadButton: `Subir música`,
    close: `Cerrar`,
    nameLabel: `Nombre de la pista`,
    namePlaceholder: `Ingrese el nombre de la pista`,
    nameRequired: `Por favor, ingrese un nombre para la pista.`,
    audioFileRequired: `Por favor, seleccione un archivo de audio.`,
    fileTypeInvalid: `Solo se admiten archivos WAV o MP3.`,
    fileSizeExceeded: `El archivo excede el límite de 25 MB ({{size}} MB).`,
    dropzonePlaceholder: `Arrastre y suelte un archivo WAV o MP3 aquí, o haga clic para buscar`,
    dropzoneAccepted: `WAV, MP3 (máx. 25 MB)`,
    removeFile: `Quitar`,
    cancel: `Cancelar`,
    uploadSubmit: `Subir`,
    uploading: `Subiendo...`,
    uploadFailed: `Error al subir`,
    deleteConfirmTitle: `¿Eliminar pista de audio?`,
    deleteConfirmBody: `¿Eliminar "{{name}}"? Esta acción no se puede deshacer.`,
    deleteConfirm: `Eliminar`,
    deleteFailed: `Error al eliminar`,
    deleteAriaLabel: `Eliminar pista de audio`,
  },
  createModal: {
    title: `Nueva lista de reproducción`,
    nameLabel: `Nombre`,
    namePlaceholder: `Introduzca el nombre de la lista`,
    cancel: `Cerrar`,
    submit: `Crear lista`,
  },
  editModal: {
    title: `Editar lista`,
    nameLabel: `Nombre`,
    namePlaceholder: `Introduzca el nombre de la lista`,
    cancel: `Cancelar`,
    submit: `Guardar cambios`,
    error: `Error al guardar la lista`,
  },
  manageTracks: {
    title: `Administrar pistas`,
    inPlaylistTitle: `En esta lista de reproducción`,
    availableTitle: `Pistas disponibles`,
    noneAssigned: `Aún no se han agregado pistas a esta lista de reproducción.`,
    noTracksUploaded: `No se han subido pistas de audio para esta centralita.`,
    allAdded: `Todas las pistas disponibles ya están en esta lista de reproducción.`,
    add: `Agregar`,
    remove: `Quitar`,
    done: `Listo`,
    addFailed: `Error al agregar la pista`,
    removeFailed: `Error al quitar la pista`,
  },
  trackPlay: {
    play: `Reproducir`,
    loading: `Cargando…`,
    error: `Vista previa no disponible`,
    close: `Cerrar vista previa`,
  },
  pagination: {
    resultsPerPage: `Resultados por página:`,
    previousPage: `Página anterior`,
    nextPage: `Página siguiente`,
    jumpToPage: `Ir a la página {{page}}`,
    all: `Todos`,
  },
} satisfies MusicOnHoldLocale
